import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
//enviroment
import { environment } from "../../environments/environment";
//formulario
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";

//lodash
import * as _ from "lodash";

/** RXJS */
import { Observable, of, from, Subject, forkJoin, BehaviorSubject } from "rxjs";
import { tap, map, mergeMap, take } from "rxjs/operators";
import { ajax } from "rxjs/ajax";

@Injectable({
  providedIn: "root",
})
export class PacientesService {
  constructor(private http: HttpClient, private _formBuilder: FormBuilder) {}

  public url: string = environment.production.serviceUrl;
  private settings = environment.production.settings;

  subject: BehaviorSubject<any[]> = new BehaviorSubject<any>([]);
  array$: Observable<any> = this.subject.asObservable();

  getPacientesByFilters(rut: string): Observable<any> {
    var query_string = `?q={"rut":{"lk":"${rut}"}}`;

    return this.http
      .get(this.url + `pacientes` + query_string, this.settings)
      .pipe(map((result: Response) => result));
  }

  getPacientes(): Observable<any> {

    return this.http
      .get(this.url + `pacientes`, this.settings)
      .pipe(map((result: Response) => result));

  }

  getApoderadosById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getArchivosById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }
  getCargasById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }
  getCitasById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getConveniosById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getDevolucionesById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getEvolucionesById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getPagosById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getTratamientosById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getAdicionalesById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getTareasById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getRecetasById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }
  getNotificacionesGesById(service: string, id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}/${service}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getEstadoById(id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/estados/${id}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getSucursalById(id: number): Observable<any> {
    return this.http
      .get(this.url + `sucursales/${id}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getTreatmentById(id: number): Observable<any> {
    return this.http
      .get(this.url + `tratamientos/${id}`, this.settings)
      .pipe(map((result: Response) => result));
  }

  getPacienteById(id: number): Observable<any> {
    return this.http
      .get(this.url + `pacientes/${id}`, this.settings)
      .pipe(map((result: Response) => result));
  }


  // FORMULARIO
  formulario: FormGroup = new FormGroup({
    id: new FormControl(null),
    nombre: new FormControl("", Validators.required),
    apellido: new FormControl("", Validators.required),
    especialidades: new FormControl("", Validators.required),
    estado: new FormControl(true, Validators.required),
  });

  initializeFormGroup() {
    this.formulario.setValue({
      id: null,
      nombre: "",
      apellido: "",
      especialidades: "",
      estado: true,
    });
  }

  insertProfesional(profesional) {
  }

  updateProfesional(profesional) {
  }

  //DELETE
  deleteProducto(id: Number) {
    //this.contactList.remove(id);
  }

  populateForm(profesional) {
    const { id, nombre, apellido, especialidades, estado } = profesional;

    if (localStorage.getItem("profesional") === null) {
      localStorage.setItem("profesional", JSON.stringify(profesional));
    } else {
      localStorage.removeItem("profesional");
      localStorage.setItem("profesional", JSON.stringify(profesional));
    }
    this.formulario.patchValue({
      id,
      nombre,
      apellido,
      especialidades,
      estado,
    });
  }

  addElementToObservableArray(item) {
    this.array$.pipe(take(1)).subscribe((val) => {
      const newArr = [...val, item];
      this.subject.next(newArr);
    });
  }
}
